import { useCall } from "../../context/CallContext";

const IncomingCallModal = () => {
    const { callState, callerInfo, answerCall, rejectCall, callType } = useCall();

    if (callState !== "receiving" || !callerInfo) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-gradient-to-br from-ice-900 to-ice-950 rounded-3xl shadow-2xl p-10 max-w-md w-full">
                <div className="flex justify-center mb-6">
                    <div className="relative">
                        <div className="w-24 h-24 rounded-full bg-gradient-to-br from-ice-400 to-ice-600 flex items-center justify-center text-white text-3xl font-bold shadow-2xl ring-4 ring-ice-400/30">
                            {callerInfo.username.charAt(0).toUpperCase()}
                        </div>
                        {callerInfo.userId && (
                            <div className="absolute bottom-1 right-1 w-6 h-6 bg-green-500 border-4 border-ice-900 rounded-full"></div>
                        )}
                    </div>
                </div>


                <h2 className="text-3xl font-bold text-white mb-3 text-center">
                    {callerInfo.username}
                </h2>


                <div className="flex items-center justify-center gap-2 text-ice-300 text-lg mb-10">
                    {callType === "video" ? (
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
                        </svg>
                    ) : (
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                        </svg>
                    )}
                    <span>Incoming {callType} call...</span>
                </div>

                <div className="flex gap-6 justify-center">
                    <button
                        onClick={rejectCall}
                        className="bg-red-500 hover:bg-red-600 text-white rounded-full p-5 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-110 flex items-center justify-center"
                        title="Reject"
                    >
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    <button
                        onClick={answerCall}
                        className="bg-green-500 hover:bg-green-600 text-white rounded-full p-5 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-110 flex items-center justify-center"
                        title="Answer"
                    >
                        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default IncomingCallModal;
